export default {
	nameFieldMissing: "Meeting must have a name.",
	linkFieldMissing: "Virtual meeting link is required.",
	invalidLinkField: "Must be a Zoom, Microsoft Teams, or Google Meet link.",
	timeFieldMissing: "Meeting time is required.",
	invalidTimeField: "Meeting time is invalid.",
	meridiemFieldMissing: "Meeting meridiem is required.",
	invalidMeridiemField: "Meeting meridiem is invalid.",
	timezoneFieldMissing: "Meeting timezone is required.",
	invalidTimezoneField: "Meeting timezone is invalid.",
	startDateFieldMissing: "Meeting start date is required.",
	starTimeFieldInPast: "Meeting start time must be in the future.",
	incorrectStartDateDays: "Start date must be on {days}",
	incorrectStartDateDay: "Start date must be on the {nth} {day}",
};
